export enum MediaSelectType {
  Item = 'item',
  Complaint = 'complaint',
  UserMsg = 'user_msg',
  SupportTicket = 'support_ticket',
}
